import './GatewayContent.scss';
import { LinksFooter } from './LinksFooter';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { useNavigate } from 'react-router-dom';
import React from 'react';
export const GatewayContent = ({ children }) => {
    const navigate = useNavigate();
    return (React.createElement("div", { className: 'gateway' },
        React.createElement("div", { className: 'content' },
            React.createElement("div", { className: 'arovy-logo clickable', onClick: () => navigate('/') }),
            children ? children : React.createElement(LoadingSpinner, { size: 'large', spinning: true })),
        React.createElement(LinksFooter, null)));
};
